"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Keyboard;
(function (Keyboard) {
    Keyboard[Keyboard["Backspace"] = 8] = "Backspace";
    Keyboard[Keyboard["Enter"] = 13] = "Enter";
    Keyboard[Keyboard["Esc"] = 27] = "Esc";
    Keyboard[Keyboard["Left"] = 37] = "Left";
    Keyboard[Keyboard["Up"] = 38] = "Up";
    Keyboard[Keyboard["Right"] = 39] = "Right";
    Keyboard[Keyboard["Bottom"] = 40] = "Bottom";
})(Keyboard = exports.Keyboard || (exports.Keyboard = {}));
